import React, { useState } from 'react';
import { useHistory } from 'react-router-dom'; // Add this import
import { InputText } from '../common/input';
import './login.css';
import { all_routes } from 'core/data/routes/all_routes';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const history = useHistory(); // Add this line

    const handleSubmit = (e) => {
        e.preventDefault();
        if (username === 'artectum-admin-2025' && password === 'Admin_2025!') {
            localStorage.setItem('isAdmin', 'true');
            setError('');
            history.push(all_routes.homeBannerSlider); // Add this line
        } else {
            setError('Nombre de usuario o contraseña incorrectos');
        }
    };

    return (
        <div className="login-container">
            <h2>Iniciar Sesión</h2>
            <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                    <label>Nombre de usuario:</label>
                    <InputText
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Ingrese su correo"
                        name="username"
                    />
                </div>
                <div className="form-group">
                    <label>Contraseña:</label>
                    <InputText
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Ingrese su contraseña"
                        name="password"
                        type="password"
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="btn btn-primary">Iniciar Sesión</button>
            </form>
        </div>
    );
};

export default Login;
